import { Box, IconButton, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { RedoIcon } from 'assets/icons';
import { analytics, events } from 'services/analytics';
import { actions } from 'services/store/remixer';
import {
  checkCurrentSongLoading,
  checkRedoDisabled,
} from 'services/store/remixer/selectors';
import { FormulaButton } from '../../../../FormulaItem/styles';

const RedoButton = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleRedoClick = () => {
    dispatch(actions.redo());
    analytics.track(events.studioRedoButtonClick());
  };
  const isRedoDisabled = useSelector(checkRedoDisabled);
  const isLoading = useSelector(checkCurrentSongLoading);
  const isDisabled = isRedoDisabled || isLoading;

  return (
    <Box>
      {isMobile ? (
        <IconButton
          onClick={handleRedoClick}
          size="small"
          disabled={isDisabled}
        >
          <RedoIcon />
        </IconButton>
      ) : (
        <FormulaButton
          onClick={handleRedoClick}
          disabled={isDisabled}
          startIcon={<RedoIcon />}
        >
          {t('remixer:redo')}
        </FormulaButton>
      )}
    </Box>
  );
};

export default RedoButton;
